export const API_URL = `https://forkify-api.herokuapp.com/api/v2/recipes`;
export const TIMEOUT_SEC = 10;
export const NUMBER_RESULT = 10;
export const API_KEY = `2bca8300-f701-4ce0-b008-efc046cb306f`;
